import { InvoiceType, PlanFeatureTypeArray, PlanPriceType, PlanType } from '@/lib/types/PlanT'
import { PaymentMethod, SubscriptionType } from '@/lib/types/SubscriptionT'
import { deleteRequest, getRequest, postRequest, putRequest } from '@/lib/request'

export const getSubscriptionPlans = (): Promise<PlanType[]> => {
  return getRequest('/admin/plans')
}

/**
 * Returns a list of subscription plans that are better than the current plan
 * based on the authenticated user's session token
 */
export const getBetterSubscriptionPlans = (): Promise<PlanType[]> => {
  return getRequest('/admin/plans/better')
}

export const getSubscriptionPlan = (planId: number): Promise<PlanType> => {
  return getRequest(`/admin/plans/${planId}`)
}

export const getActiveFeatures = (): Promise<PlanFeatureTypeArray> => {
  return getRequest('/admin/companies/subscriptions/active/features')
}

export const getSubscriptionInfo = (): Promise<SubscriptionType> => {
  return getRequest('/admin/companies/subscription')
}

export const getScheduledSubscriptionSwitch = (): Promise<PlanPriceType> => {
  return getRequest('/admin/companies/plan/switch/scheduled')
}

export const scheduleCancel = () => {
  return postRequest('/admin/companies/subscriptions/schedule-cancel', null, {
    showToast: true,
    pendingMessage: 'Scheduling subscription cancellation...',
    successMessage: 'Subscription cancellation scheduled successfully!',
    errorMessage: 'Failed to schedule subscription cancellation. Please try again.',
    customErrorMessagesByCode: {
      10023: 'Cancellation is only allowed for active subscriptions.',
    },
  })
}

export const unscheduleCancellation = () => {
  return postRequest('/admin/companies/subscriptions/unschedule-cancel', null, {
    showToast: true,
    pendingMessage: 'Unscheduling subscription cancellation...',
    successMessage: 'Subscription cancellation unscheduled successfully!',
    errorMessage: 'Failed to unschedule subscription cancellation. Please try again.',
    customErrorMessagesByCode: {
      10023: 'Only cancelled subscriptions can be activated.',
    },
  })
}

export const getSuitablePlan = (params: { maxParticipants: number }): Promise<PlanType> => {
  return getRequest('/plans/suggestion', params)
}

export const getBillingHistory = (params: {
  page: number
  size: number
}): Promise<{
  data: InvoiceType[]
  total: number
  page: number
  lastPage: number
}> => {
  return getRequest('/admin/companies/current/invoices', params)
}

export const getPaymentMethods = (): Promise<PaymentMethod[]> => {
  return getRequest('/admin/companies/current/payment-methods')
}

export const setDefaultPaymentMethod = (paymentMethodId: string) => {
  return putRequest(`/admin/companies/current/payment-methods/${paymentMethodId}/default`, null, {
    showToast: true,
    pendingMessage: 'Setting default payment method...',
    successMessage: 'Default payment method updated successfully!',
    errorMessage: 'Failed to set default payment method.',
  })
}

export const deletePaymentMethod = (paymentMethodId: string) => {
  return deleteRequest(`/admin/companies/current/payment-methods/${paymentMethodId}`, null, {
    showToast: true,
    pendingMessage: 'Deleting payment method...',
    successMessage: 'Payment method deleted successfully!',
    errorMessage: 'Failed to delete payment method.',
  })
}
